import { render, staticRenderFns } from "./radioDesc.vue?vue&type=template&id=703c4918&scoped=true"
import script from "./radioDesc.vue?vue&type=script&lang=js"
export * from "./radioDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c4918",
  null
  
)

export default component.exports